import { isBoolean, isFinite, isNumber, isString } from 'lodash';

/* eslint-disable no-underscore-dangle */

/* Helpers */
function getIntOrNull(value) {
    if (isString(value)) {
        const number = parseInt(value, 10);
        return isFinite(number) ? number : null;
    }
    if (isNumber(value)) {
        return isFinite(value) ? Math.round(value) : null;
    }
    return null;
}

function getStringOrNull(value) {
    return isString(value) ? value : null;
}

/* Service */
class ConfigsService {
    constructor() {
        this.__organizationId = null;
        this.__organizationUnitId = null;
        this.__organizationUnitLocation = null;
        this.__location = null;
        this.__websiteId = null;
        this.__isInMobileApp = null;
        this.__deskingToken = null;
        this.__isShowroomV25Enabled = null;
    }

    setOrganizationId(organizationId) {
        this.__organizationId = getIntOrNull(organizationId);
    }

    getOrganizationId() {
        return this.__organizationId;
    }

    setOrganizationUnitId(organizationUnitId) {
        this.__organizationUnitId = getIntOrNull(organizationUnitId);
    }

    getOrganizationUnitId() {
        return this.__organizationUnitId;
    }

    setOrganizationUnitLocation(organizationUnitLocation) {
        const unitLocation = getStringOrNull(organizationUnitLocation);
        this.__organizationUnitLocation = unitLocation ? unitLocation.trim().toLowerCase() : null;
    }

    getOrganizationUnitLocation() {
        return this.__organizationUnitLocation;
    }

    setLocation(location) {
        this.__location = getStringOrNull(location);
    }

    getLocation() {
        return this.__location;
    }

    setWebsiteId(websiteId) {
        this.__websiteId = getIntOrNull(websiteId);
    }

    getWebsiteId() {
        return this.__websiteId;
    }

    isInMobileApp() {
        return this.__isInMobileApp;
    }

    setIsInMobileApp(value) {
        this.__isInMobileApp = isBoolean(value) ? value : false;
    }

    /**
     * @return {string} The token given by CRM to call the Showroom API
     */
    getDeskingToken() {
        return this.__deskingToken;
    }

    /**
     * Set the token given by CRM to call the Showroom API
     * @param {string} deskingToken
     */
    setDeskingToken(deskingToken) {
        this.__deskingToken = isString(deskingToken) ? deskingToken : null;
    }

    isShowroomV25Enabled() {
        return this.__isShowroomV25Enabled;
    }

    setIsShowroomV25Enabled(isShowroomV25Enabled) {
        this.__isShowroomV25Enabled = isBoolean(isShowroomV25Enabled) ? isShowroomV25Enabled : false;
    }

    /**
     * @return {Object} An object with properties to identify the context
     */
    getLoggerContext() {
        return {
            organizationId: this.__organizationId,
            organizationUnitId: this.__organizationUnitId,
            websiteId: this.__websiteId,
            mobileApp: this.__isInMobileApp,
        };
    }
}

export default new ConfigsService();



// WEBPACK FOOTER //
// ./src/services/ConfigsService/ConfigsService.js